import { useLocation, useNavigate } from "react-router-dom";
import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';
import Moment from 'moment';

// material
import { Typography, Button, Box, Stack, Tooltip, TextField, IconButton, InputAdornment, Card, FormControl, FormLabel, Autocomplete, Grid, Chip, Modal } from '@mui/material';
import { styled } from '@mui/material/styles';
import XLSX from 'sheetjs-style';
import * as FileSaver from 'file-saver';
import { Icon } from '@iconify/react';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ScheduleIcon from '@mui/icons-material/Schedule';
// components
import AddIcon from "@mui/icons-material/Add";

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ModalPopUp from '../../Common/ModalPopUp';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import Page from "../../Page";
import StickyHeader from "../../Common/StickyHeader";
import ServiceCards from '../../Common/ServiceCard'

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\s+/g, ' ').trim(); // collapse whitespace and remove line breaks
};

export default function RoutineIssueManagementListing() {
    const navigate = useNavigate();
    const location = useLocation();

    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    const userId = CurrentLoggedInUser.ExecutiveId;
    // const [editServiceData, setEditServiceData] = useState([]);
    const [searchServiceId, setSearchServiceId] = useState('');
    const [issueId, setIssueId] = useState("");
    const [showDetails, setShowDetails] = useState(false);

    const [editData, setEditData] = useState([]);
    const [filteredServiceData, setFilteredServiceData] = useState(editData);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [issueData, setIssueData] = useState([]);
    const [issueIdExist, setIssueIdExist] = useState(false);
    const [selectedIssueId, setSelectedIssueId] = useState(null);

    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.filterRoutineIssueId(issueId || 0)
            .then((response) => {


                if (Array.isArray(response.data) && response.data[0]?.Error) {
                    setEditData([]);
                    setIsLoading(false);
                    enqueueSnackbar("Data not found", { variant: 'error' });

                } else {
                    setEditData(response.data);

                    console.log("+++++++++++++++", response.data)
                    setIsLoading(false);
                    enqueueSnackbar("Fetched Data Successfully.", { variant: 'success' });
                }
            })
            .catch(error => {
                setEditData([]);
                enqueueSnackbar("Data not found", { variant: 'error' });
                setIsLoading(false);

            });

    }, []);

    useEffect(() => {
        if (searchServiceId.trim() === '') {
            // No search → show full list
            setFilteredServiceData(editData);
        } else {
            const match = editData.find(
                (item) => String(item.Id) === searchServiceId.trim()
            );
            setFilteredServiceData(match ? [match] : []);
        }
    }, [searchServiceId, editData]);

    const handleIssueId = (e) => {
        setIssueId(e.target.value);
    };

    const handleCancel = () => {
        setIssueId("");
        setIssueData([]);
        setShowDetails(false);
        setSearchServiceId("");
    }
    const handleClick = (event, rowData) => {
        console.log("rowData", rowData)
        navigate('/dashboard/servicedetailspage', {
            state: {
                loadData: rowData,

            }
        });
        console.log("************************", rowData);
    };

    const onFilterClick = () => {
        if (!issueId) {
            enqueueSnackbar("Please Enter an Issue ID.");
            return;
        }
        setIsLoading(true);

        // 1. Check in editData first
        if (Array.isArray(editData) && editData.length > 0) {
            const match = editData.filter(
                (item) => String(item?.Id || item?.issueId) === String(issueId)
            );

            if (match.length > 0) {
                setIssueData(match);
                setIsLoading(false);
                setShowDetails(true);
                setIssueIdExist(true);
                return;
            }
        }

        // 2. If not found → call loadService API
        const payload = {
            ClientIdList: [0],
            SiteIdList: [0],
            ExecutiveID: 0,
            ContactPersonId: 0,
            frmDate: "",
            toDate: "",
            Status: 2,
            IssueOwnedById: "",
            Date: 0,
            OrderBy: "",
            IncludeChilren: 0,
            PriorityId: 0,
            SubStatusIdList: [0],
            IssueCategoryIdList: [0],
            IssueId: Number(issueId) || 0,
            ProjectIdList: [0],
            IssueCreatededById: 0
        };

        URLS.loadService(payload).then((res) => {
            if (Array.isArray(res.data) && res.data.length > 0) {
                setIssueData(res.data);
                setShowDetails(true);
                setIssueIdExist(false);

            } else {
                setIssueData([]);
                enqueueSnackbar("Data not found", { variant: 'error' });
                setShowDetails(false);
                setIssueIdExist(false);

            }
            setIsLoading(false);
        }).catch((error) => {
            console.error("loadService error:", error);
            enqueueSnackbar("Data not found", { variant: 'error' });

            setShowDetails(false);
            setIssueIdExist(false);
        })
    };

    const handleDeleteConfirm = (value) => {
        if (value) {
            handleDelete(); // Your existing save logic
        }
        setOpenDeleteModal(false);
    };
    const handleDeleteClick = (row) => {
        setSelectedIssueId(row?.Id || row?.issueId);
        setOpenDeleteModal(true);
    };
    console.log("selectedIssueId", selectedIssueId)
    const handleAddIssue = () => {
        setIsLoading(true);

        const payload = {
            IssueId: Number(issueId) || 0,
            UserId: userId || 0,
        };

        URLS.insertRoutineIssue(payload)
            .then((response) => {
                if (response.status === 200) {
                    URLS.filterRoutineIssueId(0)
                        .then((response) => {
                            if (Array.isArray(response.data) && response.data[0]?.Error) {
                                setEditData([]);

                            } else {
                                setEditData(response.data);
                                handleCancel();
                                enqueueSnackbar("Routine Issue added successfully.", {
                                    variant: "success",
                                });
                            }
                            setIsLoading(false); // stop loader after refresh completes
                        })
                        .catch((error) => {
                            console.error("Refresh Error:", error);
                            setEditData([]);

                            setIsLoading(false);
                        });
                }
                // else {
                //    enqueueSnackbar("Failed to delete Routine Issue ID.", { variant: "error" });
                //    setIsLoading(false);
                // }
            })
            .catch((error) => {
                console.error("Delete Error:", error);
                enqueueSnackbar("Failed to add Routine Issue .", { variant: "error" });

                setIsLoading(false);
            });

    };

    const handleDeleteIssue = () => {
        setIsLoading(true);

        const payload = {
            IssueId: Number(issueId) || 0,
            UserId: userId || 0,
        };

        URLS.deleteRoutineIssue(payload)
            .then((response) => {
                if (response.status === 200) {
                    URLS.filterRoutineIssueId(0)
                        .then((response) => {
                            if (Array.isArray(response.data) && response.data[0]?.Error) {
                                setEditData([]);

                            } else {
                                setEditData(response.data);
                                handleCancel();
                                enqueueSnackbar("Routine Issue deleted successfully.", {
                                    variant: "success",
                                });
                            }
                            setIsLoading(false); // stop loader after refresh completes
                        })
                        .catch((error) => {
                            console.error("Refresh Error:", error);
                            setEditData([]);

                            setIsLoading(false);
                        });
                }
                // else {
                //    enqueueSnackbar("Failed to delete Routine Issue ID.", { variant: "error" });
                //    setIsLoading(false);
                // }
            })
            .catch((error) => {
                console.error("Delete Error:", error);
                enqueueSnackbar("Failed to delete Routine Issue.", { variant: "error" });

                setIsLoading(false);
            });
    };
    const handleDelete = () => {
        setIsLoading(true);

        const payload = {
            IssueId: Number(selectedIssueId) || 0,
            UserId: userId || 0,
        };

        URLS.deleteRoutineIssue(payload)
            .then((response) => {
                if (response.status === 200) {
                    URLS.filterRoutineIssueId(0)
                        .then((response) => {
                            if (Array.isArray(response.data) && response.data[0]?.Error) {
                                setEditData([]);

                            } else {
                                setEditData(response.data);
                                handleCancel();
                                enqueueSnackbar("Routine Issue deleted successfully.", {
                                    variant: "success",
                                });
                            }
                            setIsLoading(false); // stop loader after refresh completes
                        })
                        .catch((error) => {
                            console.error("Refresh Error:", error);
                            setEditData([]);

                            setIsLoading(false);
                        });
                }
                // else {
                //    enqueueSnackbar("Failed to delete Routine Issue ID.", { variant: "error" });
                //    setIsLoading(false);
                // }
            })
            .catch((error) => {
                console.error("Delete Error:", error);
                enqueueSnackbar("Failed to delete Routine Issue.", { variant: "error" });

                setIsLoading(false);
            });
    };
    const getPriorityStyle = (priority) => {
        switch (priority?.toLowerCase()) {
            case 'high':
                return { bg: '#FFE2E2', color: '#9F0712' };
            case 'medium':
                return { bg: '#FEF9C2', color: '#894B00' };
            default:
                return { bg: '#E3F2FD', color: '#1976D2' };
        }
    };

    useEffect(() => {
        handleCancel();
    }, [location.key]);

    return (
        <Box sx={{
            display: 'flex', gap: 2, px: 1.5, overflow: 'hidden'
        }}>
            <Box sx={{ flex: 4, height: showDetails ? '472px' : '135px', }}>
                <Card
                    sx={{
                        p: 0,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        border: '1px solid #E5E5E5',
                        boxShadow: 'none',
                        borderRadius: '12px',
                    }}
                >
                    {/* HEADER */}
                    <Box
                        sx={{
                            py: 1,
                            px: 2,
                            borderBottom: '1px solid #E5E5E5',
                        }}
                    >
                        <Typography variant="subtitle1" fontWeight={600}>
                            Manage Routine
                        </Typography>
                        <Typography sx={{ color: '#94A3B8', fontSize: '12px' }}>
                            Add or remove an issue from the routine using Issue ID
                        </Typography>
                    </Box>

                    {/* ISSUE ID */}
                    <Box sx={{ flex: 1, overflow: 'auto' }}>

                        <Box sx={{ px: 2, py: 1 }}>
                            <FormLabel sx={{ mb: 0.5, fontSize: '13px' }}>
                                Issue ID
                            </FormLabel>

                            <Stack direction="row" spacing={2} alignItems="center">
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={issueId}
                                    onChange={handleIssueId}
                                    type="number"
                                    placeholder="Enter Issue Id"
                                    sx={{
                                        backgroundColor: '#F9FAFB',
                                        borderRadius: '8px',
                                    }}
                                />

                                <Button
                                    sx={{
                                        width: '96px',
                                        height: '36px',
                                        backgroundColor: issueId ? '#E8F6EE' : '#F3F3F5',
                                        '&:hover': {
                                            backgroundColor: issueId ? '#E8F6EE' : '#F3F3F5',
                                        },
                                        color: issueId ? '#2E7D32' : '#717883',
                                        border: issueId ? '1px solid #B7E4C7' : '1px solid #D1D5DB',
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        boxShadow: 'none',

                                    }}
                                    onClick={onFilterClick}
                                >
                                    Search
                                </Button>
                            </Stack>
                        </Box>
                        {showDetails && issueData.length > 0 && issueData.map((item) => (
                            <>
                                {/* ISSUE DETAILS LABEL */}
                                < Box sx={{ px: 2, }}>
                                    <FormLabel sx={{ fontSize: '13px' }}>
                                        Issue Details
                                    </FormLabel>
                                </Box>

                                {/* ISSUE DETAILS CARD */}
                                <Box sx={{ px: 2, pt: '4px', flex: 1 }}>
                                    <Card
                                        sx={{
                                            p: 1,
                                            border: '1px solid #E5E5E5',
                                            borderRadius: '12px',
                                            boxShadow: 'none',
                                        }}
                                    >
                                        {/* TOP ROW */}
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="flex-start"
                                            gap={2}
                                            mb={1.5}
                                        >
                                            {/* LEFT */}
                                            <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="center"
                                                gap={1.5}
                                                sx={{ flex: 1 }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#FC3838',
                                                        fontWeight: 600,
                                                        fontSize: '14px',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {item?.Id}
                                                </Typography>

                                                <Typography fontWeight={500} fontSize="14px">
                                                    {item?.ProjectName || item?.IssueCategoryName}
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: 'inline-flex',
                                                        height: '20px',
                                                        px: 1,
                                                        borderRadius: '6px',
                                                        border: '1px solid #E5E5E5',
                                                        fontSize: '10px',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        whiteSpace: 'nowrap',
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {item?.AllocationLagDays} / {item?.LagDays}
                                                </Box>

                                                <Chip
                                                    label={item?.Priority || ""}
                                                    size="small"
                                                    sx={{
                                                        height: '20px',
                                                        borderRadius: '6px',
                                                        fontSize: '11px',
                                                        backgroundColor: getPriorityStyle(item?.Priority).bg,
                                                        color: getPriorityStyle(item?.Priority).color,
                                                    }}
                                                />
                                            </Box>
                                        </Box>

                                        {/* DETAILS */}
                                        <Grid container spacing={1} >
                                            <Grid item xs={4}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <CalendarMonthIcon sx={{ color: '#9A9A9A', fontSize: 14 }} />
                                                    <Typography sx={{ color: '#9A9A9A', fontSize: '10px', fontWeight: 500 }}>
                                                        Issue Date
                                                    </Typography>
                                                </Box>
                                                <Typography fontSize="12px">
                                                    {item?.Date ? Moment(item?.Date).format("DD MMM YYYY, HH:mm") : ""}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={4}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <ScheduleIcon sx={{ color: '#9A9A9A', fontSize: 14 }} />
                                                    <Typography sx={{ color: '#9A9A9A', fontSize: '10px', fontWeight: 500 }}>
                                                        Appointment Date
                                                    </Typography>
                                                </Box>
                                                <Typography fontSize="12px">
                                                    {item?.AppointmentDate ? Moment(item?.AppointmentDate).format("DD MMM YYYY, HH:mm") : ""}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography fontSize="12px" fontWeight={500}>
                                                    Client/Site:{' '}
                                                    <Typography component="span" color="#716F6F">
                                                        {item?.ClientName} : {item?.Site}
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography fontSize="12px" fontWeight={500}>
                                                    Owned by:{' '}
                                                    <Typography component="span" color="#716F6F">
                                                        {item?.IssueOwnedBy}
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography fontSize="12px" fontWeight={500}>
                                                    Last remark:{' '}
                                                    <Typography component="span" color="#716F6F" dangerouslySetInnerHTML={{
                                                        __html: (item?.LastService || "").replace(/\n/g, "<br/>"),
                                                    }} />
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography fontSize="12px" fontWeight={500}>
                                                    Issue remark:{' '}
                                                    <Typography component="span" color="#716F6F" dangerouslySetInnerHTML={{
                                                        __html: (item.Remarks || "").replace(/\n/g, "<br/>"),
                                                    }} />
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Box>

                                {showDetails && (
                                    <>
                                        {/* INFO BOX */}
                                        <Box sx={{ px: 2, py: 1 }}>
                                            <Card
                                                sx={{
                                                    p: 1,
                                                    border: '1px solid #E5E5E5',
                                                    borderRadius: '10px',
                                                    boxShadow: 'none',
                                                    backgroundColor: '#FFFFFF',
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'flex-start'
                                                    }}
                                                >
                                                    <InfoOutlinedIcon
                                                        sx={{
                                                            mr: 1,
                                                            width: 16,
                                                            height: 16,
                                                            mt: '2px',
                                                            color: issueIdExist ? '#D82F50' : '#7F7F8F',
                                                        }}
                                                    />

                                                    <Typography
                                                        fontSize="12px"
                                                        fontWeight="500"
                                                        lineHeight={1.4}
                                                        color={issueIdExist ? '#D82F50' : '#7F7F8F'}

                                                    >
                                                        {issueIdExist
                                                            ?
                                                            " Are you sure want to remove this issue from the routine list? This will be a Permanent deletion and the issue will appear in the default pending issue list"
                                                            : "Are you sure you want to add this issue to the routine list? It will not appear in the default pending issue list."}
                                                    </Typography>
                                                </Box>
                                            </Card>
                                        </Box >
                                    </>

                                )}
                            </>
                        ))}
                    </Box>
                    {showDetails && (
                        <>
                            {/* FOOTER BUTTONS */}
                            < Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: 1.5,
                                    borderTop: '1px solid #E5E5E5',
                                }}
                            >

                                <Button
                                    variant="outlined"
                                    sx={{
                                        width: '96px',
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                    }}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                                {issueIdExist ? (
                                    <Button

                                        variant="contained"
                                        sx={{
                                            width: '134px',
                                            borderRadius: '8px',
                                            backgroundColor: '#D4183D',
                                            textTransform: 'none',
                                            '&:hover': {
                                                backgroundColor: '#D4183D',
                                            },
                                        }}
                                        onClick={handleDeleteIssue}
                                    >
                                        Confirm Delete
                                    </Button>
                                ) : (

                                    <Button
                                        variant="contained"
                                        sx={{
                                            width: '96px',
                                            borderRadius: '8px',
                                            backgroundColor: '#2E7D32',
                                            textTransform: 'none',

                                        }}
                                        onClick={handleAddIssue}

                                    >
                                        Confirm
                                    </Button>
                                )}
                            </Box>
                        </>
                    )}

                </Card>

            </Box >

            <Box sx={{ flex: 6, position: 'relative', display: 'flex', height: '472px', }}>
                <Card sx={{
                    borderRadius: '12px', width: "100%", border: '1px solid #E5E5E5', boxShadow: 'none', display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Box
                        sx={{
                            py: 1,
                            px: 2,
                            borderBottom: '1px solid #E5E5E5',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            height: '55px'
                        }}
                    >
                        <Typography variant="subtitle1" fontWeight={600}>
                            Current Routine Issues
                        </Typography>

                        <Box
                            sx={{
                                width: '50px',
                                height: '30px',
                                borderRadius: '8px',
                                boxShadow: '0px 0px 2px 0px #0000002E',
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#666060',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '#FFFFFF',
                            }}
                        >
                            {editData?.length}
                        </Box>

                        {/* RIGHT ALIGNED SEARCH */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}>
                            <TextField
                                size="small"
                                placeholder="Search By Service ID"
                                value={searchServiceId}
                                onChange={(e) => setSearchServiceId(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <ManageSearchOutlinedIcon sx={{ color: '#989898', width: 22, height: 22 }} />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    height: 35,
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#FFFFFF',
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        backgroundColor: '#FFFFFF',
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                    {/* Scrollable Service Cards Section */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: 'auto',
                            px: 0,
                        }}
                    >
                        {filteredServiceData?.length > 0 ? (
                            filteredServiceData?.map((item, index) => (
                                <Box key={item.issueId || index} sx={{ px: 2, py: 1, }}>
                                    <Card
                                        sx={{
                                            p: 1,
                                            border: '1px solid #E5E5E5',
                                            borderRadius: '12px',
                                            boxShadow: 'none',
                                        }}
                                    >
                                        {/* TOP ROW */}
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="flex-start"
                                            gap={2}
                                            mb={1.5}
                                        >
                                            {/* LEFT */}
                                            <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="center"
                                                gap={1.5}
                                                sx={{ flex: 1 }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#FC3838',
                                                        fontWeight: 600,
                                                        fontSize: '14px',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {item.Id}
                                                </Typography>

                                                <Typography fontWeight={500} fontSize="14px">
                                                    {item.ProjectName}:{item.IssueCategoryName}
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: 'inline-flex',
                                                        height: '20px',
                                                        px: 1,
                                                        borderRadius: '6px',
                                                        border: '1px solid #E5E5E5',
                                                        fontSize: '10px',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        whiteSpace: 'nowrap',
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {item.AllocationLagDays} / {item.LagDays}
                                                </Box>

                                                <Chip
                                                    label={item?.Priority || ""}
                                                    size="small"
                                                    sx={{
                                                        height: '20px',
                                                        borderRadius: '6px',
                                                        fontSize: '11px',
                                                        backgroundColor: getPriorityStyle(item?.Priority).bg,
                                                        color: getPriorityStyle(item?.Priority).color,
                                                    }}
                                                />
                                            </Box>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={(e) => handleClick(e, item)}
                                                sx={{
                                                    width: '80px',
                                                    height: '28px',
                                                    borderRadius: '9px',
                                                    fontSize: '12px',
                                                    textTransform: 'none',
                                                    alignSelf: 'flex-start',
                                                    fontWeight: 600,
                                                }}
                                            >
                                                Service
                                            </Button>
                                            <IconButton
                                                sx={{
                                                    width: '28px',
                                                    height: '28px',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#D82F50',
                                                    color: '#FFFFFF',
                                                    '&:hover': {
                                                        backgroundColor: '#D82F50',
                                                    },
                                                }}
                                                onClick={() => handleDeleteClick(item)}
                                            >
                                                <Icon icon="material-symbols:delete-outline" width="16" height="16" />
                                            </IconButton>
                                        </Box>

                                        {/* DETAILS */}
                                        <Grid container spacing={1}>
                                            <Grid item xs={4}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <CalendarMonthIcon sx={{ color: '#9A9A9A', fontSize: 14 }} />
                                                    <Typography sx={{ color: '#9A9A9A', fontSize: '10px', fontWeight: 500 }}>
                                                        Issue Date
                                                    </Typography>
                                                </Box>
                                                <Typography fontSize="12px">
                                                    {item.Date ? Moment(item.Date).format('DD-MMM-YYYY HH:mm') : ''}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={4}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <ScheduleIcon sx={{ color: '#9A9A9A', fontSize: 14 }} />
                                                    <Typography sx={{ color: '#9A9A9A', fontSize: '10px', fontWeight: 500 }}>
                                                        Appointment Date
                                                    </Typography>
                                                </Box>
                                                <Typography fontSize="12px">
                                                    {item.AppointmentDate ? Moment(item.AppointmentDate).format('DD-MMM-YYYY HH:mm') : ''}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography fontSize="12px" fontWeight={500}>
                                                    Client/Site:{' '}
                                                    <Typography component="span" color="#716F6F">
                                                        {item.ClientName} : {item.Site}
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography fontSize="12px" fontWeight={500}>
                                                    Owned by:{' '}
                                                    <Typography component="span" color="#716F6F">
                                                        {item.IssueOwnedBy}
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography fontSize="12px" fontWeight={500}>
                                                    Last remark:{' '}
                                                    <Typography component="span" color="#716F6F" dangerouslySetInnerHTML={{
                                                        __html: (item?.IssueCategory_LastRemark || "").replace(/\n/g, "<br/>"),
                                                    }} />

                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography fontSize="12px" fontWeight={500} >
                                                    Issue remark:{' '}
                                                    <Typography component="span" color="#716F6F" dangerouslySetInnerHTML={{
                                                        __html: (item?.Remarks || "").replace(/\n/g, "<br/>"),
                                                    }} />

                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Box>
                            ))
                        ) : (
                            <Box
                                sx={{
                                    height: '68vh',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography sx={{ color: '#E7000B', fontSize: 16, fontWeight: '500' }}>
                                    No Data Found
                                </Typography>
                            </Box>
                        )}
                    </Box>

                </Card>
            </Box>


            {isLoading && (<LoadingProgressBar sx={{ py: 9 }} />)}
            {openDeleteModal && (
                <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 444,
                            bgcolor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "none",
                            p: 1,
                            height: 138
                        }}
                    >
                        {/* MESSAGE */}
                        <Typography fontSize="14px" lineHeight="22px">
                            Are you sure want to remove{" "}
                            <span style={{ color: "#FF2B2B", fontWeight: 400 }}>
                                “{selectedIssueId}”
                            </span>{" "}
                            issue from the routine list? This will be a Permanent deletion and the
                            issue will appear in the default pending issue list.
                        </Typography>

                        {/* ACTIONS */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: 2,
                                mt: 3,
                            }}
                        >
                            {/* NO */}
                            <Typography
                                onClick={() => setOpenDeleteModal(false)}
                                sx={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    fontWeight: 600,
                                    color: "#000",
                                    fontSize: '14px'
                                }}
                            >
                                No
                            </Typography>

                            {/* YES */}
                            <Button
                                variant="contained"
                                onClick={() => handleDeleteConfirm(true)}
                                sx={{
                                    backgroundColor: "#FF2B2B",
                                    borderRadius: "8px",
                                    px: 3,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    "&:hover": {
                                        backgroundColor: "#FF2B2B",
                                    },
                                    fontSize: '14px'

                                }}
                            >
                                Yes
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            )}
        </Box >


    );
}

